import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatError } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(formatError(err)); }
  };
  return (
    <div className="min-h-screen grid place-items-center p-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="font-serif text-2xl mb-4">Reset password</h1>
        {sent ? (
          <p data-testid="forgot-sent-msg" className="text-sm text-muted-foreground">If that email is registered, a reset link has been sent.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input data-testid="forgot-email-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} required /></div>
            <Button data-testid="forgot-submit-btn" type="submit" className="w-full">Send reset link</Button>
          </form>
        )}
        <Link to="/login" className="text-sm mt-4 block text-muted-foreground">Back to sign in</Link>
      </Card>
    </div>
  );
}
